import { Injectable } from '@angular/core';
import { Article, CartItem, Price, PriceService, SalesCreditNoteItem, SalesOfferItem, SalesOrderItem, SteelCartItem } from '@lobos/library';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ArticleHelperService {
  constructor(private priceService: PriceService) {}

  public itemIsMaster<T extends CartItem>(item: CartItem | SalesOrderItem | SalesOfferItem | SalesCreditNoteItem | T): boolean {
    if (item.shtFixedItemIDItemGroup) {
      return item.shtFixedItemIDItemGroup === 0 || item.shtFixedItemIDItemGroup === item.shtFixedItemID;
    } else {
      return true;
    }
  }

  public itemIsChildOf(
    child: CartItem | SalesOrderItem | SalesOfferItem | SalesCreditNoteItem,
    master: CartItem | SalesOrderItem | SalesOfferItem | SalesCreditNoteItem,
  ): boolean {
    if (child.shtFixedItemIDItemGroup) {
      return (
        child.shtFixedItemIDItemGroup !== 0 &&
        child.shtFixedItemIDItemGroup === master.shtFixedItemIDItemGroup &&
        child.shtFixedItemIDItemGroup !== child.shtFixedItemID
      );
    } else {
      return false;
    }
  }

  public getPriceFromApi(article: Article): Observable<Price | undefined> {
    return this.priceService.get(
      article.sArticleID,
      article.sQuantityUnitSales,
      environment.defaultCurrency,
      article.decQty > 0 ? article.decQty : 1,
      article.decFactor1,
      article.decFactor2,
      article.decFactor3,
    );
  }

  public isNotProcessedItem(item: SteelCartItem): boolean {
    return item.shtProcessedItem === 0;
  }

  public isProcessedChildOf(child: SteelCartItem, master: SteelCartItem): boolean {
    return child.shtProcessedItem !== 0 && child.shtProcessedItem === master.shtFixedItemID;
  }
}
